(() => {
  document.querySelectorAll('.js-accordion .accordion-title').forEach((item) => {
    const toggleAccordion = (e) => {
      // Close other accordions
      if (!e.classList.contains('nActive')) {
        e.closest('.js-accordion').querySelectorAll('.nActive').forEach((accordion) => {
          accordion.classList.remove('nActive');
          accordion.nextElementSibling.style.maxHeight = null;
        });
      }

      // toggle clicked accordion
      e.classList.toggle('nActive');
      const panel = e.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      }
    };

    item.addEventListener('click', () => {
      toggleAccordion(item);
    });

    item.addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      toggleAccordion(item);
    });
  });
})();
